import React from 'react'
import Manager from '../../../public/components/Manager'
import SupplierEvaluateDiv from './SupplierEvaluateDiv'
Ext.require('Ext.Toast')

const config = {
    buttons: [],
    columns: [
        { _text: '评价编号', field: 'SupplierEvaluateApply.Number', search: true, flex: 1, locked: false },
        { _text: '申请原因', field: 'SupplierEvaluateApply.Reason', flex: 1, },
        { _text: '供应商名称', field: 'SupplierName', search: true, flex: 1 },
        { _int: '供应商评分', field: 'TotalScore', flex: 1 },
        { _: 'taskName', field: 'Task.TaskName' }
    ],
    onDoubleTap: ({ showDetail }, data) => showDetail(props => <SupplierEvaluateDiv {...props} id={data.id} taskName={data.taskName} />),
}

export default props => <Manager {...props} config={config} />